import React from 'react';

class DevMenu extends React.Component{
    render(){
        return(
            <div className="quizMenu">
                <ul>
                    <li>About </li> | <li> Sprachtest </li> | <li> Sprachen lernen</li>
                </ul>
            </div>
        );
    }

}
export default DevMenu;
